/**
 * Proxy/Wrapper para epaycoCheckout
 *
 * Este archivo delega a la versión correcta de EpaycoCheckout basándose en
 * la variable de entorno config.epaycoCheckoutVersion:
 * - "2" -> usa epaycoCheckoutV2.ts
 * - "1" o undefined -> usa epaycoCheckoutV1.ts
 */

import * as V1 from './epaycoCheckoutV1';
import * as V2 from './epaycoCheckoutV2';
import config from "../config/enviroment";

/**
 * Wrapper para EpaycoCheckout
 * Recibe todos los parámetros y los delega a la versión correcta
 */
export const EpaycoCheckout = async (
	...args: Parameters<typeof V1.EpaycoCheckout>
): Promise<void> => {
	const useV2 = config.epaycoCheckoutVersion === "2";

	if (useV2) {
		return await V2.EpaycoCheckout(...args);
	} else {
		return await V1.EpaycoCheckout(...args);
	}
};

/**
 * Wrapper para currencyFormat
 * Recibe todos los parámetros y los delega a la versión correcta
 */
export const currencyFormat = (
	...args: Parameters<typeof V1.currencyFormat>
): string => {
	const useV2 = config.epaycoCheckoutVersion === "2";

	return useV2
		? V2.currencyFormat(...args)
		: V1.currencyFormat(...args);
};
